import { Alert } from 'src/app/models/alert';
import { AlertTypes } from 'src/app/models/alertTypes';
import { resolveFaultDisplay } from 'src/app/shared/handler/common-functions.util';

export type FaultNow = 'active' | 'cleared' | null;

export interface FaultLine {
  triggeredAlert: boolean;
  now: FaultNow;
  protocol: string;
  faultType: string;
  description: string;
  controller: number;
  controllerDisplay: string;
  faultCode: number;
  faultCodeDisplay: string;
  failureCode: number;
  failureCodeDisplay: string;
  faultCount: string;
  faultDateUtc: Date;
}

export function buildFaultLines(alert: Alert, alertTypes: AlertTypes): FaultLine[] {
  const seen = new Set<string>();
  const lines: FaultLine[] = [];
  for (const f of alert.faults ?? []) {
    const key = `${f.protocol}|${f.faultCode}|${f.failureCode}|${f.sourceAddress}|${f.groupId}|${f.faultType}|${f.description}`;
    if (seen.has(key)) continue;
    seen.add(key);
    const display = resolveFaultDisplay(alertTypes, f);
    lines.push({
      triggeredAlert: f.triggeredAlert,
      now: null,
      protocol: f.protocol,
      faultType: f.faultType,
      description: f.description,
      controller: f.sourceAddress,
      controllerDisplay: display.controllerDisplay,
      faultCode: f.faultCode,
      faultCodeDisplay: display.faultCodeDisplay,
      failureCode: f.failureCode,
      failureCodeDisplay: display.failureCodeDisplay,
      faultCount: f.faultCount,
      faultDateUtc: f.faultDateUtc,
    });
  }
  return lines;
}

export function faultCodeLabel(fault: FaultLine, translate: (key: string, params: object) => string): string {
  switch (fault.protocol) {
    case 'OBDII': return translate('@issueFaultCodeObd', { code: fault.faultCodeDisplay || fault.faultCode, address: fault.controller });
    case 'J1708': return translate('@issueFaultCodeJ1708', { code: fault.faultCode, fmi: fault.failureCode });
    default: return translate('@issueFaultCodeBus', { spn: fault.faultCode, fmi: fault.failureCode });
  }
}
